var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"site_button",staticClass:"site_button",class:{ 'no-border': _vm.border === 'no', primary: _vm.type === 'primary' },style:({
      '--site-button-colour': _vm.colour,
      '--site-button-text-colour': _vm.button_text_colour,
      '--min-height': _vm.minHeight + 'px',
      '--border-thickness': _vm.borderThickness + 'px',
			'--margin-top': _vm.margin_top + 'px',
			'--margin-bottom': _vm.margin_bottom + 'px',
			'--margin-right': _vm.margin_right + 'px',
			'--margin-left': _vm.margin_left + 'px',
			'--display-type': _vm.display_type
    }),attrs:{"href":_vm.button_link.url ? _vm.button_link.url : _vm.link,"target":_vm.button_link.target ? _vm.button_link.target : _vm.target},on:{"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.button_label ? _vm.button_label : _vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/SiteButton.vue?vue&type=template&id=13c8a20a&scoped=true&
// module id = 148
// module chunks = 0